import type { JiraIssue } from '../api/JiraApi';

/** Material Table uses `id` to preserve selection state; Jira issue keys are unique. */
export type JiraIssueTableRow = JiraIssue & { id: string };

export function jiraIssuesToTableRows(
  issues: JiraIssue[],
): JiraIssueTableRow[] {
  return issues.map(issue => ({ ...issue, id: issue.key }));
}
